module.exports = __webpack_public_path__ + "static/media/book_demo_down.db43c335.svg";